import { DirectionsBoat, FeaturedPlayList } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { InvoiceFormField } from "./InvoiceFormField";

export const InvoiceHeaderDetails = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <FeaturedPlayList style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("InvoiceHeaderDetails")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <InvoiceFormField label={t("Date")} type="disabledDate" code="InvoiceDate" data={dataState} setData={setDataState} />
            <InvoiceFormField label={t("DueDate")} type="disabledDate" code="DueDate" data={dataState} setData={setDataState} />
            <div>
                <InvoiceFormField label={t("Accounted")} type="disabledCheckBox" code="Accounted" data={dataState} setData={setDataState} />
                <InvoiceFormField label={t("Lock")} type="disabledCheckBox" code="Lock" data={dataState} setData={setDataState} />
            </div>
          </div>
        }
      />
    </>
  )
}